<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
 	  <!-----------  批量新增客户信息 --------------->
 	  <div class="backborder3">
 	      <el-tag type="danger">温馨提示：上传客户信息时请戳下方使用系统模板，谢绝使用自定义模板</el-tag>
          <el-form width="100%" style="margin-top:10px">
              <el-col :span="10">
	          	  <el-form-item>
	                  <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
	                  <el-button type="primary" size="small" icon="el-icon-download" @click="getdownmoremodel">下载模板</el-button>
	                  <el-button type="warning" size="small" icon="el-icon-upload2" @click="getaddmoremodel">上传数据</el-button>
	              </el-form-item>
              </el-col>
          </el-form>
          <el-table :data="inputcustomers" v-loading="inputlistLoading" size="small">
	          <el-table-column prop="name" label="客户名称" align="center"></el-table-column>
	          <el-table-column prop="simple" label="客户简称" align="center"></el-table-column>
	          <el-table-column prop="number" label="客户编号" width="100" align="center"></el-table-column>
	          <el-table-column prop="phone" label="联系电话" width="115" align="center"></el-table-column>
	          <el-table-column prop="cate" label="客户分类" align="center"></el-table-column>
	          <el-table-column prop="clerk" label="负责销售员" align="center"></el-table-column>
	          <el-table-column prop="maxreceivable" label="应收款上限" align="center"></el-table-column>
	          <el-table-column prop="receivable" label="期初应收款" align="center"></el-table-column>
	          <el-table-column prop="advance" label="预存款" align="center"></el-table-column>
	          <el-table-column prop="city" label="所在城市" align="center"></el-table-column>
	          <el-table-column prop="district" label="所在区域" align="center"></el-table-column>
	          <el-table-column prop="address" label="地址" align="center"></el-table-column>
	          <el-table-column prop="note" label="备注" align="center"></el-table-column>      
          </el-table>
          <div slot="footer" class="dialog-footer" style="margin-top:20px;text-align:right">
              <el-button size="small" type="primary" :loading="createmoreLoading" @click="createmoreSave">保 存</el-button>
          </div>
      </div>
  </div>
  </transition>
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作权限
      transitionshow:true,
      url:this.GLOBAL.domain+"Customer/index",
      morecustomerDialog:false,
      morecustomerDialog:false,
      inputcustomers:[],
      inputlistLoading:false,
      createmoreLoading:false,
      
    }
  },
  mounted(){
      this.getactionauth();
      
  },
  methods:{  
  	//重置表单
    reset() {
        this.$refs.create.resetFields();
    },
  
  	/** 获取操作权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    /************** 导入excel表格数据 **************/
    importfile(obj) {    
    	let _this = this;
        let inputDOM = this.$refs.inputer;
        // 通过DOM取文件数据
        this.file = event.currentTarget.files[0];                
        var rABS = false; //是否将文件读取为二进制字符串
        var f = this.file;
        var outdata;
        var reader = new FileReader();
        FileReader.prototype.readAsBinaryString = function(f) {
        	var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;
                
                //提交数据到后台
                _this.inputlistLoading=true;
        		var resource = _this.$resource(_this.url);
                resource.save({act:'inputinfos',infos:outdata,token:_this.$cookies.get('token')}).then((res) => {
                    if(res.data.Result>0){
                    	if(res.data.Result=='70001') this.$router.push('/login')
                    	_this.inputlistLoading=false;
                    	_this.$message({
				    		dangerouslyUseHTMLString: true,
				    		type:'error',
				    		message:'<span style="line-height:20px">'+res.data.Message+'</span>',
			    		});
                    }else{
                    	_this.inputcustomers=JSON.parse(Base64.decode(res.data.Data));
                    	_this.inputlistLoading=false;
                  	}
                }).catch((res) => {
                    _this.inputlistLoading=false;
                });        
                           
            }
            reader.readAsArrayBuffer(f);
        }
               
        if(rABS) {
        	reader.readAsArrayBuffer(f);
        } else {
            reader.readAsBinaryString(f);
        }
                  
    },
    /************* 导入excel表格数据 *****************/
    
    //下载批量导入数据模板
    getdownmoremodel() {
    	location.href=this.GLOBAL.domain+"ChangeFile/getcustomerexport";
    },
    
    //上传模板数据
    getaddmoremodel() {
    	document.getElementById("fileupload").click();
    },
    
    //保存批量导入会员信息
    createmoreSave() {
    	if(this.inputcustomers.length==0) {this.$message.error('请导入会员信息');return false;}
    	this.createmoreLoading=true;
    	var resource = this.$resource(this.url);
        resource.save({act:'saveinput',token:this.$cookies.get('token'),data:this.inputcustomers}).then((res) => {
            if(res.data.Result>0){
            	if(res.data.Result=='70001') this.$router.push('/login')
            	this.createmoreLoading=false;
            	this.$message.error(res.data.Message);
            }else {
            	this.$message.success("批量导入客户信息成功");
            	this.createmoreLoading=false;
            	this.inputcustomers=[];
            }
        }).catch((res) => {
            
        });
    },
    
    
  }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder3 {background:#fff;border-radius:15px;border:1px solid #ddd;float:left;width:98%;padding:1% 1% 1% 1%;}
</style>


// WEBPACK FOOTER //
// src/components/base/Customermoreadd.vue